module.exports = __webpack_public_path__ + "assets/img/login-home-page2.19ef7f99.png";